import waRequest from './wa-request';

const baseApi = '/cem-pipelines/v1';

function getPipeline({params: {pipelineUId}}) {
  const url = `${baseApi}/pipelines/${pipelineUId}`;

  return waRequest.requestAuthenticated({url, method: 'GET'});
}

function getPipelineDefinitions({params: {organizationUId, isOrganizationSubscribed, sortField, sortDirection}}) {
  const url = `${baseApi}/pipelines/pipeline-definitions`;

  return waRequest.requestAuthenticated({
    url,
    method: 'GET',
    params: {
      organizationUId,
      isOrganizationSubscribed,
      sortField,
      sortDirection,
      /**
       * Even though the UI will NOT display paginated results, since this new service was “imported” from the TopoOne project,
       * this endpoint returns paginated data.
       * As a result we should default the “page” size to something large like 500.
       * For this service, the “page” size query param is called take - so we should pass take=500
       *
       * HORIZONWEB-13452
       */
      take: '500',
    },
  });
}
function updatePipeline({params: {pipelineUId, data}}) {
  const url = `${baseApi}/pipelines/${pipelineUId}`;

  return waRequest.requestAuthenticated({url, method: 'PUT', data});
}

function updatePipelineConnection({params: {pipelineUId, isConnectionEnabled}}) {
  const url = `${baseApi}/pipelines/${pipelineUId}/is-active`;

  return waRequest.requestAuthenticated({url, method: 'PUT', data: {isActive: !isConnectionEnabled}});
}

/**
 * `updatePipelineDefinitions` function allows toggling the subscription on or off
 *
 * Toggling On (Subscribed)
 *
 * 'method' - 'POST'
 * 'organizationUId' - is the id of the organization being configured
 * 'pipelineUId' - is the uId of the pipeline associated with the row in that table being subscribed
 *
 *
 *
 * Toggling Off (Unsubscribed)
 *
 * 'method' - 'DELETE'
 * organizationUId is the id of the organization being configured
 * pipelineUId is the uId of the pipeline associated with the row in that table being subscribed
 *
 * */
function updatePipelineDefinitions({params: {method, organizationUId, pipelineUId}}) {
  const url = `${baseApi}/pipelines/pipeline-definitions/organization/${organizationUId}/${pipelineUId}`;

  return waRequest.requestAuthenticated({url, method});
}

export default {
  getPipeline,
  getPipelineDefinitions,
  updatePipelineConnection,
  updatePipelineDefinitions,
  updatePipeline,
};
